const nextRoutes = require('next-routes')
const routes = module.exports = nextRoutes()

routes.add('blog', '/blog/:slug?')
routes.add('article', '/articles/:slug?')
routes.add('video', '/videos/:slug?')
routes.add('generic', '/:pagename')
   // beta   v3        /v3